var map = {
	"./1.png": "23ed",
	"./2.png": "6b79",
	"./3.png": "d58c",
	"./awning-01.png": "e097",
	"./character-01.png": "cd9f",
	"./gack.png": "1ce3",
	"./train-01.png": "341a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fec7";